import CryptoJS from 'crypto-js'

// The sign-in form has always wrapped usernames and passwords in AES-CBC with this key and IV
// (MegaPayBackend Models/Auth/PanelCredentialCipher reads them). It keeps the values out of
// casual reading of request bodies; HTTPS is what protects them.
const KEY = CryptoJS.enc.Utf8.parse('p3qHeFAs00k996dD')
const IV = CryptoJS.enc.Utf8.parse('JS3RIEOv3i2AAw2F')

export const wrapCredential = (value: string): string =>
  CryptoJS.AES.encrypt(value, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString()
